export type Feature = {
  id: string;
  feature: string;
  ios: string;
  android: string;
};

const features: Feature[] = [
  {
    id: "1",
    feature: "HAC (Hearing Aid Compatibility)",
    ios: "Available on HAC-rated devices",
    android: "Available on HAC-rated devices",
  },
  {
    id: "2",
    feature: "TTY/TDD Support",
    ios: "Available with compatible accessories",
    android: "Available with compatible accessories",
  },
  {
    id: "3",
    feature: "Real Time Text (RTT)",
    ios: "iOS 10+ with carrier support",
    android: "Android 9+ with carrier support",
  },
  {
    id: "4",
    feature: "VoLTE (Voice over LTE)",
    ios: "iPhone6 and newer",
    android: "Most devices 2016+",
  },
  {
    id: "5",
    feature: "Wi-Fi Calling",
    ios: "iPhone6 and newer",
    android: "Most devices 2015+",
  },
  {
    id: "6",
    feature: "Visual Voicemail",
    ios: "iPhone6 and compatible Android",
    android: "Available on most smartphones",
  },
  {
    id: "7",
    feature: "Closed Captioning",
    ios: "Native iOS support",
    android: "Native Android support",
  },
  {
    id: "8",
    feature: "Speech-to-Text",
    ios: "Siri and Dictation",
    android: "Google Assistant and voice typing",
  },
  {
    id: "9",
    feature: "Text-to-Speech",
    ios: "VoiceOver (iOS)",
    android: "TalkBack (Android)",
  },
  {
    id: "10",
    feature: "Screen Magnification",
    ios: "Zoom feature",
    android: "Magnification gestures",
  },
  {
    id: "11",
    feature: "High Contrast Display",
    ios: "Display Accommodations",
    android: "High contrast text and themes",
  },
  {
    id: "12",
    feature: "Large Text Options",
    ios: "Dynamic Type",
    android: "Font size adjustment",
  },
  {
    id: "13",
    feature: "Switch Control",
    ios: "Full switch support",
    android: "Switch Access",
  },
  {
    id: "14",
    feature: "Voice Control",
    ios: "Available iOS 13+",
    android: "Voice Access",
  },
];

export { features };
